import React from 'react';
import './styles.css';

export default function CarouselTitle(props) {
    const { provided, snapshot, option } = props;
    
    return(
        <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            id = 'painel-carrosseis_area-title'
            style={{
                ...provided.draggableProps.style,
                backgroundColor: snapshot.isDragging ? 'lightblue' : 'lightgrey',
            }}
        >
            <p id = 'painel-carrosseis_area-title-text'>
                {option.text}
            </p>
        </div>
    );
}